export default function getWords(value?: string): string[] {
  return (
    value?.match(
      /(\p{L}|\p{N}|\p{Pc})+|(\p{M}|\p{S}|\p{Pi}|\p{Pf}|\p{Ps}|\p{Ps}|\p{Pe}|\p{Po}|\p{Pd}|\p{Z}|\p{C})+/gu
    ) || []
  )
}
